import React from 'react';
import { GoogleAuthProvider, EmailAuthProvider } from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import Welcome from '../Welcome';
import { auth } from './config';

const uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      // User successfully signed in.
      // Don't redirect automatically, let React handle the state change
      return false;
    }
  },
  signInFlow: 'popup',
  signInOptions: [
    {
      provider: GoogleAuthProvider.PROVIDER_ID,
      scopes: ['email', 'profile']
    },
    {
      provider: EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: false
    }
  ]
};

// Initialize the FirebaseUI Widget using Firebase - use singleton pattern
let ui = null;

// Function to get or create Firebase UI instance
const getFirebaseUI = () => {
  if (!ui) {
    try {
      ui = new firebaseui.auth.AuthUI(auth);
    } catch (error) {
      // Try to get existing instance
      try {
        ui = firebaseui.auth.AuthUI.getInstance();
      } catch (getError) {
        console.error('Could not get Firebase UI instance:', getError);
      }
    }
  }
  return ui;
};

const AuthDiv = (props) => {
  React.useEffect(() => {
    // Wait a bit for DOM to be ready
    setTimeout(() => {
      const container = document.getElementById('firebaseui-auth-container');

      if (container) {
        // Clear any existing content
        container.innerHTML = '';

        // Get or create Firebase UI instance
        const uiInstance = getFirebaseUI();

        if (uiInstance) {
          try {
            uiInstance.start('#firebaseui-auth-container', uiConfig);
          } catch (startError) {
            console.error('Error starting Firebase UI:', startError);
          }
        }
      }
    }, 200);

    return () => {
      // No cleanup needed since we're using a singleton
    };
  }, []);

  return (
    <div>
      <Welcome />
      <div id="firebaseui-auth-container">
      </div>
    </div>
  );
}

export default AuthDiv;
